module.exports = __webpack_public_path__ + "img/investBW.60936709.png";